var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
* Migrations for the "siteInfo" object of the website.
* - Migrate new shared config settings into siteInfo for LanguageSelector widget.
*/
export default function siteInfoMigrations(siteInfo) {
    if (siteInfo.sharedConfigs.LanguageSelector) {
        return siteInfo;
    }
    return __assign(__assign({}, siteInfo), { sharedConfigs: __assign(__assign({}, siteInfo.sharedConfigs), { LanguageSelector: {
                displayFormat: 'Dropdown',
                selectorLabel: 'NucleusWidgets_LanguageSelectorWidget_DefaultLabel__resx'
            } }) });
}
